const Chart = () => {
  return (
    <div
      id="chart"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:pb-36"
    >
      <div
        id="title"
        className="relative w-full h-fit text-center mb-5 xl:mb-10"
      >
        <h2 className="font-medium">
          근면 성실! 노력으로&nbsp;성장하는&nbsp;
          <span className="text-primary">싹!&nbsp;치워드림</span>
        </h2>
      </div>
      <div className=" relative w-full h-[1px] max-w-[1600px] mx-auto bg-black opacity-5 mb-5 xl:mb-10"></div>
      <div className="relative w-full h-fit max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-2 lg:gap-4">
        <div data-aos="fade-up" className=" relative w-full">
          <img src="/images/chart1.png" alt="싹치워드림 연도별 작업 실적 그래프" />
        </div>
        <div data-aos="fade-up" className=" relative w-full">
          <img src="/images/chart2.png" alt="싹치워드림 고객 만족도 성장 그래프" />
        </div>
      </div>
      <div className=" text-center mt-6">
        <h4 className="font-medium hidden lg:block">
          <span className="text-primary">정직한 견적</span>과{" "}
          <span className="text-primary">확실한 일처리</span>로 고객만족을
          실현하며
          <span className="text-primary">
            매년 성장해나가고 있는 싹! 치워드림
          </span>
          입니다.
          <br /> 매번{" "}
          <span className="text-primary">재문의해주시는 고객님!</span>{" "}
          처음임에도{" "}
          <span className="text-primary">믿고 문의해주신 고객님! </span>
          모두 감사합니다.
        </h4>
        <p className="block lg:hidden text-sm">
          <span className="text-primary">정직한 견적</span>과{" "}
          <span className="text-primary">확실한 일처리</span>로 고객만족을
          실현하며{" "}
          <span className="text-primary">
            매년&nbsp;성장해나가고&nbsp;있는&nbsp;싹!&nbsp;치워드림
          </span>
          입니다.
          <br /> 매번&nbsp;
          <span className="text-primary">재문의해주시는&nbsp;고객님!</span>{" "}
          처음임에도&nbsp;
          <span className="text-primary">
            믿고&nbsp;문의해주신&nbsp;고객님!{" "}
          </span>
          모두&nbsp;감사합니다.
        </p>
      </div>
    </div>
  );
};

export default Chart;
